var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 4H6.7C5.2 4 4 5.2 4 6.7v20c0 1.5 1.2 2.7 2.7 2.7h16.4c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H6.7c-.5 0-.9-.4-.9-.9v-20c0-.5.4-.9.9-.9h5.9v6c0 .5.6 1.1 1.3.8l2.5-1.3 2.1 1.5c.2.2.5.2.7.1l2.8-.8c.4-.1.7-.5.7-.8V5.8h5.9c.5 0 .9.4.9.9v10.6c0 .5.4.9.9.9s.9-.4.9-.9V6.7C31.1 5.2 29.9 4 28.4 4zm-7.6 6.6l-1.7.5-2.2-1.6c-.2-.2-.6-.2-1-.1l-1.7.9V5.8h6.5v4.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 34.2h-.3c-.2-3-1.5-5.4-3.3-6.7 1.8-1.2 3-3.7 3.3-6.7h.3c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H22.5c-.5 0-.9.4-.9.9s.4.9.9.9h.5c.2 3 1.5 5.4 3.3 6.7-1.8 1.2-3 3.7-3.3 6.7h-.5c-.5 0-.9.4-.9.9s.4.9.9.9h12.7c.5 0 .9-.4.9-.9s-.4-.9-1-.9zm-10.3 0c.3-3.3 2-5.9 4.1-5.9 2 0 3.8 2.6 4.1 5.9h-8.2zM33 20.8c-.3 3.3-2 5.9-4.2 5.9-2 0-3.8-2.6-4.2-5.9H33z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackTime);
export default __webpack_public_path__ + "static/media/pack-time.ebfbcfa8.svg";
export { ForwardRef as ReactComponent };